import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateTimeUtils } from '@app/shared/util/date-time.utils';

@Component({
  selector: 'app-ticket-status',
  templateUrl: './ticket-status.component.html',
  styleUrls: ['./ticket-status.component.scss']
})
export class TicketStatusComponent implements OnInit {
  @Input() ticket: any;

  startBubbleExpanded = false;
  finishBubbleExpanded = false;

  @Output() downloadFile = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  isExpanded(operation: any) {
    const index = this.ticket.ticketOperations.findIndex(op => op.id === operation.id);
    if (index < 0) {
      return false;
    }

    return this.ticket.ticketOperations[index].expanded || false;
  }

  toggleExpanded(operation: any) {
    const index = this.ticket.ticketOperations.findIndex(op => op.id === operation.id);
    if (index < 0) {
      return;
    }
    this.startBubbleExpanded = false;
    this.finishBubbleExpanded = false;
    this.ticket.ticketOperations[index].expanded = !(this.ticket.ticketOperations[index].expanded || false);

    for (let i = 0; i < this.ticket.ticketOperations.length; i++) {
      if (i !== index) {
        this.ticket.ticketOperations[i].expanded = false;
      }
    }
  }

  toggleInfoBubble(isStart: boolean) {
    this.ticket.ticketOperations.forEach(to => to.expanded = false);
    if (isStart) {
      this.startBubbleExpanded = !this.startBubbleExpanded;
      this.finishBubbleExpanded = false;
    } else {
      this.finishBubbleExpanded = !this.finishBubbleExpanded;
      this.startBubbleExpanded = false;
    }
  }

  downloadDocument(event: Event, operation) {
    event.stopPropagation();
    this.downloadFile.emit(operation.document);
  }

  computeTimeSpent(operation: any) {
    const timeDifference = DateTimeUtils.extractTime(operation.endDate) - DateTimeUtils.extractTime(operation.startDate);
    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60 * 60))
    return `${this.formatDateNumber(hours)}:${this.formatDateNumber(minutes)}:${this.formatDateNumber(seconds)}`;
  }

  private formatDateNumber(number: number) {
    return number < 10 ? `0${number}` : `${number}`
  }

  get operations() {
    const operations = [];

    this.ticket.ticketOperations.forEach(operation => {
      const index = operations.findIndex(op => op.operationId === operation.operationId);
      if (index < 0) {
        operations.push({...operation});
      } else {
        operations[index].nrOfTasks += operation.nrOfTasks;
      }
    });
    return operations;
  }
}
